import { reportBusinessData, BUSINESS_DATA_TYPE } from './commonReport';

/**
 * 订单到达率统计上报 https://km.sankuai.com/page/290076211
 */

enum ORDER_ARRIVE_EVENT {
    PUSH_ARRIVED = 10101,
    PUSH_DETAIL_SUCCESS = 10102,
    POLLING_DETAIL_SUCCESS = 10201,
    LIST_LOAD_SUCCESS = 10301,
}

enum ORDER_OPERATE_EVENT {
    AUTO_ACCEPT = 20101,
    MANUAL_ACCEPT = 20102,
    CANCEL_ORDER = 20201,
}

// 缓存已上报列表避免重复上报
let cache: string[] = [];
const cacheLength = 100;

// 更新缓存
const setCache = (cacheItems: string[]) => {
    // 函数执行是在回调中，需要二次判断，避免重复
    cacheItems = cacheItems.filter(function(item) {
        return cache.indexOf(item) === -1;
    });
    // 放到数组左侧，并清除右侧多余数据
    cache = cacheItems.concat(cache).slice(0, cacheLength);
};

/**
 * 上报订单到达率相关事件
 *
 * @param eventType 事件类型
 * @param orderViewIdList 订单viewId列表
 */
const reportEvent = (
    eventType: ORDER_ARRIVE_EVENT | ORDER_OPERATE_EVENT,
    orderViewIdList: string[],
) => {
    if (!eventType || !orderViewIdList) {
        return;
    }

    // 过滤掉已经上报的数据
    const reportIds = orderViewIdList.filter(orderViewId => {
        const idStr = `${orderViewId}-${eventType}`;
        return cache.indexOf(idStr) === -1;
    });

    if (reportIds.length === 0) {
        return;
    }

    const reportData = {
        eventId: eventType,
        orderViewIds: reportIds,
    };

    const cacheItems = reportIds.map(id => `${id}-${eventType}`);
    let cacheSetted = false;

    reportBusinessData(BUSINESS_DATA_TYPE.ORDER_STAT, reportData).then(() => {
        if (!cacheSetted) {
            setCache(cacheItems);
            cacheSetted = true;
        }
    });
};

export { ORDER_ARRIVE_EVENT, ORDER_OPERATE_EVENT, reportEvent };
